// Module
var code = "<div class=\"flex flex-container-row site-details\" ng-if=\"vm.currentTab === 'forecasting' && ('Security.Settings.SiteDetails.Forecasting' | webPermission: 'readOnly')\"> <div class=\"flex flex-container-row\" ng-include src=\"'configuration.html'\"/> </div>";
// Exports
module.exports = code;